// @internal
export function hasEntity(entities, id) {
    return entities.hasOwnProperty(id);
}
//# sourceMappingURL=hasEntity.js.map